
import { computed, defineComponent, PropType } from 'vue'

const __default__ = defineComponent({
  name: 'AlFormGroup',
  props: {
    errors: {
      type: Array as PropType<string[]>,
      default: () => [],
    },
    spacing: {
      type: String,
      default: '1rem',
    },
  },
  setup (props) {
    const errors = computed(() => props.errors.filter(v => v))
    const error = computed(() => errors.value.length ? errors.value[0] : '')

    return {
      error,
    }
  },
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars((_vm, _setup) => ({
  "534b80c3": (_vm.spacing)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__